<template>
  <div id="gallery" class="full-gallery" :style="gallery_style">
    <div
      id="current-image"
      class="current-image"
      :style="current_image_style"
    ></div>

    <span
      title="close"
      class="full-gallery-close"
      v-on:click="closeGallery"
    ></span>
    <a class="previous-btn" href="#" v-on:click="nextImage"></a>
    <a class="next-btn" href="#" v-on:click="previousImage"></a>
  </div>
</template>

<script>
import axios from "axios";

const GALLERY_API = window.APP_INFO.init.REST_PREFIX + "/wp-json/gallery/v1/";
let visibilityInterval = null;
let touchsurface = null,
  startX,
  startY,
  dist,
  threshold = 150,
  allowedTime = 400,
  elapsedTime,
  startTime;

export default {
  name: "Gallery",
  data() {
    return {
      gallery_style: { opacity: 0, display: "none" },
      current_image_style: {
        backgroundImage: "none",
        opacity: 0,
      },
      current_image_index: 0,
      images_count: 0,
      collection: [],
    };
  },
  props: {
    images_ids: {
      type: Array,
      required: false,
    },
  },
  watch: {
    images_ids: function (newValue) {
      console.log("watch");
      this.images_count = this.images_ids.length;
      /*this.gallery_style.display = 'block';
                this.gallery_style.opacity = '1';
                this.setGalleryImage(0);
                console.log(this.images_ids)*/
      this.setVisible();
    },
  },
  methods: {
    closeGallery(e) {
      console.log(e);
      console.log("close");
      e.preventDefault();
      //this.player_style.opacity = '0';
      //this.$emit('close_player');
      //document.documentElement.scrollTop = 0;
      this.setUnvisibleAndClose();
    },
    setVisible() {
      const vm = this;
      console.log("setVisible");
      if (visibilityInterval != null) {
        return;
      }
      vm.gallery_style.display = "block";
      visibilityInterval = setInterval(function () {
        if (vm.gallery_style.opacity > 1) {
          clearInterval(visibilityInterval);
          visibilityInterval = null;
          vm.gallery_style.opacity = 1;
          vm.current_image_style.opacity = 1;
        } else {
          vm.gallery_style.opacity += 0.1;
        }
      }, 20);

      vm.setGalleryImage(0);
    },
    setUnvisibleAndClose() {
      const vm = this;
      console.log("setUnvisibleAndClose");
      if (visibilityInterval != null) {
        return;
      }
      visibilityInterval = setInterval(function () {
        if (vm.gallery_style.opacity <= 0) {
          clearInterval(visibilityInterval);
          visibilityInterval = null;
          vm.gallery_style.opacity = 0;
          vm.collection = [];
          vm.current_image_style.backgroundImage = "none";
          vm.gallery_style.display = "none";
          vm.current_image_style.opacity = 0;
        } else {
          vm.gallery_style.opacity -= 0.1;
        }
      }, 20);
    },
    nextImage(e) {
      e.preventDefault();
      const vm = this;
      let index = vm.current_image_index + 1;
      if (index >= vm.images_count) {
        index = 0;
      }
      vm.current_image_style.opacity = 0;
      vm.setGalleryImage(index);
    },
    previousImage(e) {
      e.preventDefault();
      const vm = this;
      let index = vm.current_image_index - 1;
      if (index < 0) {
        index = vm.images_count - 1;
      }
      vm.current_image_style.opacity = 0;
      vm.setGalleryImage(index);
    },
    getImageSizes(id) {
      const vm = this;
      console.log("get image sizes" + id);
      let image_sizes = [];
      axios.get(`${GALLERY_API}images/` + id).then(function (response) {
        console.log(response.data[0].url);
        image_sizes = response.data;
        const w = window.innerWidth;
        const h = window.innerHeight;
        let img = image_sizes[0]["url"];

        for (let i = 0; i < image_sizes.length; i++) {
          if (
            parseInt(image_sizes[i]["width"], 10) >= w &&
            parseInt(image_sizes[i]["height"], 10) >= h
          ) {
            img = image_sizes[i]["url"];
          }
        }
        vm.reloadImage(img);
      });
    },
    reloadImage(src) {
      const vm = this;
      var img = new Image();
      img.src = src;
      img.onload = function () {
        vm.current_image_style.backgroundImage = "url('" + src + "')";
        vm.current_image_style.opacity = 1;
      };
    },
    setGalleryImage(index) {
      const vm = this;
      console.log("get index " + index);

      if (
        vm.collection[index] != null &&
        vm.collection[index]["img_src"] != null
      ) {
        vm.current_image_style.backgroundImage =
          "url('" + vm.collection[index]["img_src"] + "')";
      } else {
        console.log(vm.images_ids);
        console.log(vm.images_ids[index]);
        let sizes = vm.getImageSizes(vm.images_ids[index]);
        // console.log('returned sizes ')
        //console.log(sizes)
      }
      vm.current_image_index = index;
      //vm.current_image_style.backgroundImage = 'url(\'' + img + '\')';
    },
  },
  created() {
    const vm = this;
    vm.images_count = vm.images_ids.length;
    vm.setVisible();

    setTimeout(function () {
      touchsurface = document.getElementById("current-image");

      touchsurface.addEventListener(
        "touchstart",
        function (e) {
          let touchobj = e.changedTouches[0];
          dist = 0;
          startX = touchobj.pageX;
          startY = touchobj.pageY;
          startTime = new Date().getTime();
          e.preventDefault();
        },
        false
      );

      touchsurface.addEventListener(
        "touchmove",
        function (e) {
          e.preventDefault();
        },
        false
      );

      touchsurface.addEventListener("touchend", function (e) {
        e.preventDefault();
        var touchobj = e.changedTouches[0];
        dist = touchobj.pageX - startX;
        elapsedTime = new Date().getTime() - startTime;

        if (
          elapsedTime <= allowedTime &&
          Math.abs(touchobj.pageY - startY) <= 100
        ) {
          if (dist > 0) {
            //previous
            document.querySelector(".previous-btn").click();
          } else {
            //next
            document.querySelector(".next-btn").click();
          }
        }
      });
    }, 600);
  },
};
</script>

<style scoped lang="scss">
</style>
